import style from './App.css';
import TopSection from './TopSection.js';

import { useEffect, useState } from 'react';

function App() {
  const [jsonRes, setJsonRes] = useState([]);
  useEffect(() => {
    fetch("https://www.chch.com/sched/db_work_dev.php")
      .then(response => response.json())
      .then(data => {
        // Handle the fetched data
        setJsonRes(data);
      })
      .catch(error => {
        console.error("Error fetching data:", error);
      });
  }, []);
  
  if(jsonRes.length==0){
      return (
        <div className="App" id="App">
          <div className="App-header" id="mainContApp"> 
            <div className="AppContainer" id="chchReactScheduleAppContainer">
              <h1>Loading...</h1>
            </div>
          </div>
        </div>
      );
  }

  return (
    
    <div className="App" id="App">
      <div className="App-header" id="mainContApp"> 
        <div className="AppContainer" id="chchReactScheduleAppContainer">
       
          <TopSection jsonRes={jsonRes}></TopSection>
      
        </div>
       
        </div>
      
    </div>
  );
}

export default App;
